import { AdminPageHeader } from '@/components/patterns/admin-page'
import ContractForm from '@/components/forms/ContractForm'
import { contractQueries, useContractDefaults } from '@/lib/services/contracts/contracts.query'
import { canCreateContractForOrganization } from '@/lib/services/contracts/contracts.access'
import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { FilePlus2 } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/pricing/create')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const organization = await context.queryClient.ensureQueryData(
      organizationQueries.show(params.orgId)
    )

    if (!canCreateContractForOrganization(context.ability, organization)) throw notFound()

    // load with default percentages pull from the current active contract
    void context.queryClient.ensureQueryData(
      contractQueries.defaults({ organizationId: params.orgId })
    )

    return { isReadOnly: false }
  },
})

function RouteComponent() {
  const { data: defaults } = useContractDefaults()

  return (
    <div className="space-y-6">
      <AdminPageHeader icon={FilePlus2} title="Create Pricing Version" />
      <ContractForm defaults={defaults} />
    </div>
  )
}
